<div class="image-container flex flex-column align-items-center justify-content-center">
    <img *ngIf="!loading && !error" 
         [src]="imageUrl" 
         [width]="width" 
         [height]="height" 
         [alt]="title" 
         style="border-radius: 5px; cursor: pointer;" 
         (mouseenter)="onMouseEnter($event)"
         (mouseleave)="onMouseLeave()"
         (click)="showFullScreen()">
    
    <p-skeleton *ngIf="loading && !error" [width]="width" [height]="height"></p-skeleton>
    
    <div *ngIf="error" class="flex align-items-center justify-content-center" [style.height]="height + 'px'" [style.width]="width + 'px'">
        <p-icon name="pi pi-exclamation-triangle" style="font-size: 2rem; color: var(--p-error-color);"></p-icon>
    </div>

    <p-overlayPanel *ngIf="indVoirPhotoSurSurvole" #op [showCloseIcon]="false" [dismissable]="true">
        <img *ngIf="!loading && !error" 
             [src]="imageUrl" 
             [alt]="title" 
             style="max-width: 50vw; max-height: 80vh; border-radius: 8px; box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);">
    </p-overlayPanel>
</div>
<p-dialog header="Photo" [(visible)]="isFullScreen" [modal]="true" draggable resizable maximizable closeOnEscape dismissibleMask>
    <div class="flex justify-content-center align-items-center">
        <img [src]="imageUrl" [alt]="title" style="max-width: 100vw; max-height: 90vh; border-radius: 8px; box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);">
    </div>
</p-dialog>